import { useEffect, useState } from "react";
import { COMMISSION_RATE, getTour } from "./adventureApi";

// Trade commission as a fraction; cycling tours earn 20%, everything else the default 15%.
export function useCommissionRate(tourSlug) {
  const [rate, setRate] = useState(COMMISSION_RATE);
  useEffect(() => {
    if (!tourSlug) return;
    getTour(tourSlug).then((t) => t?.commission_rate && setRate(t.commission_rate / 100)).catch(() => {});
  }, [tourSlug]);
  return rate;
}
